import React from 'react'
import ImageComponent from './image'
const SectionServicesComponent = props =>
    <div className="section--fourth">
        <div className="section__grid" id="services">
            <div className="section__text">
                <h2>Services </h2>
                <p className="section__subtitle"><strong>Lunches</strong></p>
                <p>The <strong>PZAF</strong> conference lunches (included in the registration fee) are going to take place on the <strong>27<sup>th</sup></strong> and on the <strong>28<sup>th</sup></strong> of June 2018 at <strong>Osteria Ballarò</strong>.<br />If you have any allergies to specific food products, please specify them on the PZAF Registration. Vegetarian and vegan options will be available.</p>
                <div>
                <p className="section__subtitle"><strong>Accomodations</strong></p>
                    <p>
                    We established a special agreement for student accomodations (<strong>NOT</strong> included in the registration fees) with <strong>Hotel Concordia</strong>, which is located on the fourth floor of an elegant building near the venue of the conference.<br />
                    <a className="c-btn--link" href="https://drive.google.com/open?id=1S1J5J2xnqNc-hp3YICour1CteoZgtDc2" target="_blank">Download the pdf with room prices and booking info.</a>
                    </p>
                </div>
            </div>
            <div className="section__text">
                <div className="cards">
                    <div className="card">
                        <div className="logo">
                            <ImageComponent image="osteria" />
                        </div>
                        <div className="info">
                            <p>Osteria Ballarò<br /><em>Putìa del Gusto Siciliano</em></p>
                            <a className="site" href="http://osteriaballaro.it" target="_blank">osteriaballaro.it</a>
                            <a className="location" href="https://goo.gl/maps/6AUdnvcB9AR2" target="_blank">see on map</a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="logo">
                            <ImageComponent image="concordia" />
                        </div>
                        <div className="info">
                            <p>Hotel Concordia<br /><a href="https://drive.google.com/open?id=1S1J5J2xnqNc-hp3YICour1CteoZgtDc2"><em>Room prices and booking info</em></a></p>
                            <a className="site" href="http://www.hotelconcordiapalermo.it/en-us/" target="_blank">hotelconcordiapalermo.it</a>
                            <a className="location" href="https://goo.gl/maps/Pvq7rQvw9iN2" target="_blank">see on map</a>
                        </div>
                    </div>
                </div>
        </div>
            

        </div>
    </div>

export default SectionServicesComponent



// WEBPACK FOOTER //
// ./src/components/section-services.js